import React, { useContext, useEffect } from 'react'
import { IMultistepComponent } from 'interfaces/i-multistep'
import Multistep, { MSP_ACTIONS, MspDispatchContext } from 'components/multistep/Multistep'
import { IApplicationContext } from 'interfaces/i-application-context-props'
import { ApplicationDispatchContext } from 'contexts/ApplicationContext'
import { LifeCycleStatus } from 'constants/enums/lifeCycleStatus'
import { CheckIsLifeCycleStatus } from 'utils/loanHelpers'
import ApplicationDetailsUk from 'components/application-blocks/application-offer-blocks/ApplicationDetails/ApplicationDetailsUk'
import { PreliminaryPnUK } from 'components/application-blocks/application-offer-blocks/SignPn/SignPnUK/PreliminaryPnUK'
import { SignPnUK } from 'components/application-blocks/application-offer-blocks/SignPn/SignPnUK/SignPnUK'
import { useTranslation } from 'react-i18next'
import AdditionalDetailsUk from 'components/application-blocks/application-offer-blocks/AdditionalDetails/AdditionalDetailsUk'
import ThankYouUK from 'components/application-blocks/common-blocks/ThankYou/ThankYouUK'
import { RejectedPageUk } from 'components/message-boxes/rejectedPageUk/RejectedPageUk'
import { WaitingPageUk } from 'components/message-boxes/waititngPageUK/WaitingPageUK'

export const CreditCardApplicationStepsUk = () => {
	const { t } = useTranslation()
	const { loanApplication }: IApplicationContext = useContext(
		ApplicationDispatchContext,
	)

	// the life cycle steps for which is makes sense to display the ap progress bar/pages
	const allUKLifeCycleSteps = [
		LifeCycleStatus.Offering,
		LifeCycleStatus.AwaitAccept,
		LifeCycleStatus.CustomerVerification,
		LifeCycleStatus.CustomerVerificationFailed,
		LifeCycleStatus.InternalCheck,
		LifeCycleStatus.SendToBo,
		LifeCycleStatus.Disbursed,
	]
	const displayStandardMultistepFlow = CheckIsLifeCycleStatus(
		allUKLifeCycleSteps,
		loanApplication.applicationData?.lifeCycleStatus!,
	)

	// Rejected application flow
	const displayRejectedPage = CheckIsLifeCycleStatus(
		[
			LifeCycleStatus.CreditDecisionError,
			LifeCycleStatus.Denied,
		],
		loanApplication.applicationData?.lifeCycleStatus!,
	)
	
	const { msp, dispatchMsp } = useContext(MspDispatchContext)
	const status = loanApplication.applicationData?.lifeCycleStatus

	useEffect(() => {
		if (
			status === LifeCycleStatus.CreditDecisionError ||
			status === LifeCycleStatus.Denied ||
			status === LifeCycleStatus.CreditDecisionInvestigation
		) {
			dispatchMsp({
				type: MSP_ACTIONS.RESET_STEPS,
			})
		}
	}, [status, dispatchMsp])

	const displayWaitingPage = CheckIsLifeCycleStatus(
		[LifeCycleStatus.CreditDecisionInvestigation],
		loanApplication.applicationData?.lifeCycleStatus!
	)

	const creditCardApplicationSteps: IMultistepComponent[] = [
		{
			// "ghost" experian step
			id: 1,
			label: t('ProgressBarLabelEligibility'),
			body: <></>,
			show: displayStandardMultistepFlow,
			stepCompleted: true,
		},
		{
			id: 2,
			label: t('ProgressBarLabelEligibility'),
			// header: '', // No separate header - will be part of the body
			body: <ApplicationDetailsUk />,
			show: displayStandardMultistepFlow,
			mergeProgressBarWithOtherStep: true,
			progressBarStepId: 1,
			stepCompleted: !CheckIsLifeCycleStatus(
				[LifeCycleStatus.Offering],
				loanApplication.applicationData?.lifeCycleStatus!,
			),
		},
		{
			id: 3,
			label: t('ProgressBarLabelEligibility'),
			// header: '', // No separate header - will be part of the body
			body: <AdditionalDetailsUk />,
			show: displayStandardMultistepFlow,
			mergeProgressBarWithOtherStep: true,
			progressBarStepId: 1,
			stepCompleted: !CheckIsLifeCycleStatus(
				[LifeCycleStatus.Offering],
				loanApplication.applicationData?.lifeCycleStatus!,
			),
		},
		{
			id: 4,
			label: t('ProgressBarLabelApply'),
			header: 'PreliminaryOfferHeader',
			body: <PreliminaryPnUK />,
			show: displayStandardMultistepFlow,
			stepCompleted: !CheckIsLifeCycleStatus(
				[LifeCycleStatus.Offering],
				loanApplication.applicationData?.lifeCycleStatus!,
			),
		},
		{
			id: 5,
			label: t('ProgressBarLabelSign'),
			header: 'SignContractHeader',
			body: <SignPnUK />,
			show: displayStandardMultistepFlow,
			stepCompleted: !CheckIsLifeCycleStatus(
				[LifeCycleStatus.Offering, LifeCycleStatus.AwaitAccept],
				loanApplication.applicationData?.lifeCycleStatus!,
			),
		},
		{
			id: 6,
			body: <WaitingPageUk />,
			show: displayWaitingPage,
			showProgressBar: false,
			stepCompleted: false,
		},
		{
			id: 7,
			// label: t('ProgressBarLabelSign'),
			header: 'ThankYouHeader',
			body: <ThankYouUK />,
			show: displayStandardMultistepFlow,
			showProgressBar: false,
			stepCompleted: !CheckIsLifeCycleStatus(
				[
					LifeCycleStatus.Offering,
					LifeCycleStatus.AwaitAccept,
					LifeCycleStatus.CustomerVerification,
				],
				loanApplication.applicationData?.lifeCycleStatus!,
			),
		},
		{
			id: 8,
			body: <RejectedPageUk />,
			show: displayRejectedPage,
			showProgressBar: false,
			stepCompleted: false,
		}
	]

	return (
		<Multistep
			multisteps={creditCardApplicationSteps}
			resetInitialState={false}
		/>
	)
} 